<script setup lang="ts">
  import MainLayout from 'views/layouts/MainLayout.vue'
  import LoadingTag from 'vue-loading-overlay'
  import RelatedPosts from 'components/Blog/RelatedPosts.vue'
  import IconeBds from 'assets/img/icone_BDS.png'
  import BannerAssineHorizontal from 'components/HomePage/BannerAssineHorizontal.vue'
  import JsonLD from 'components/JsonLD.vue'
  import { computed, onMounted, ref, watch } from 'vue'
  import translaters from '../../tradutors/blogs'
  import { useCookies } from 'vue3-cookies'
  import { useHead } from '@unhead/vue'
  import { localeStore } from '../../stores/locale'
  import api from '../../api'
  import { userStore } from '../../stores/user'
  import vueRecaptcha from 'vue3-recaptcha2'
  import { isMobile } from '../../views/shared/utils/mobile'
  import router from '../../router'
  import { useRoute } from 'vue-router'

  const { cookies } = useCookies()

  const route = useRoute()
  const storeLocale = localeStore()
  const { user, setUser } = userStore()

  const blog = ref({
    title: '',
    slug: 'bella-da-semana',
    content: '',
    cover: 'http:\/\/localhost\/storage\/blog\/cover-pt-1665072872-blog-1-thumb.jpg',
    date: '07\/10\/2022',
    schedule: '07\/10\/2022',
    comments: 0,
    listComents: [],
    meta_description: [
      {
        content: ''
      }
    ],
    meta_keywords: '',
    alternate_en: '',
    alternate_pt: ''
  })

  const loading = ref(false)
  const loadingButton = ref(false)
  const showButton = ref(true)
  const showRecaptchaAnswer = ref(true)
  const showRecaptcha = ref(true)
  const relatedLimit = ref(isMobile() ? 4 : 9)
  const relatedPosts = ref([])
  const bannerAssineHorizontal = ref('')
  const red = ref(null)
  const redAnswer = ref(null)
  const recaptcha = ref(null)
  const recaptchaAnswer = ref(null)
  const recaptchaSiteKey = '6LcqxykUAAAAADAOWqu2zCV2_uaW1IMDzoiKfn5J'
  const nomeComment = ref('')
  const emailComment = ref('')
  const newsletterComment = ref(true)
  const comentario = ref('')
  const nicknameComment = ref('')
  const nicknameCommentShow = ref(false)
  const nomeCommentAnswer = ref('')
  const emailCommentAnswer = ref('')
  const newsletterCommentAnswer = ref(true)
  const comentarioAnswer = ref('')
  const nicknameCommentAnswer = ref('')
  const nicknameCommentAnswerShow = ref(false)
  const answered_comment_id = ref('')

  const jsonOptions = ref({
    type: '',
    headline: '',
    datePublished: '',
    dateModified: '',
    image: '',
    author: '',
    url: ''
  })

  const translate = computed(() => {
    if (storeLocale.locale === 'pt-br') {
      return translaters.portugues
    } else {
      return translaters.ingles
    }
  })

  onMounted(() => {
    const lang = ['pt-br', 'en']
    if (!containsElement(lang, route.params.locale)) window.location.replace('/')

    getBlogName(route.params.blogId, true)
    getBannerAssineHorizontal()
  })

  function containsElement(targetArray: string[], element: string | string[]) {
    // Verifica se o elemento é um array
    if (Array.isArray(element)) {
      // Se for um array, verifica se todos os elementos estão no targetArray
      return element.every((item) => targetArray.includes(item))
    } else {
      // Se for uma string, verifica se ela está no targetArray
      return targetArray.includes(element)
    }
  }
  const reactiveLocale = computed(() => storeLocale.locale) // Certifique-se de que locale é uma ref
  watch(reactiveLocale, () => {
    getBlogName(route.params.blogId, false)
    getBannerAssineHorizontal(true)
  })

  const reactiveBlogId = computed(() => route.params.blogId)
  watch(reactiveBlogId, (newValue) => {
    getBlogName(newValue, false)
    relatedLimit.value = isMobile() ? 4 : 9
    showButton.value = true
  })

  useHead({
    templateParams: {
      subTitle: null,
      subPage: blog.value.title ?? '',
      page_url: window.location.origin + route.fullPath,
      page_description: blog.value.meta_description[0]?.content ?? '',
      page_image: blog.value.cover ?? '',
      page_keywords:
        blog.value.meta_keywords ??
        'bella, bella da semana, bela da semana, bella semana, bela semana, belladasemana, bella site, bella da semana site, bella blog',
      page_locale: storeLocale.locale,
      page_url_pt:
        'https://belladasemana.com.br/pt-br/blog/' +
        route.params.blogId +
        '/' +
        blog.value.alternate_pt,
      page_url_en:
        'https://belladasemana.com.br/en/blog/' +
        route.params.blogId +
        '/' +
        blog.value.alternate_en,
      page_canonical: 'https://belladasemana.com.br' + route.fullPath
    }
  })

  function recaptchaExpired() {
    red.value.reset()
  }
  function recaptchaExpiredAnswer() {
    redAnswer.value.reset()
  }
  function recaptchaUpdated(recaptchaIn) {
    recaptcha.value = recaptchaIn
  }
  function recaptchaUpdatedAnswer(recaptcha) {
    recaptchaAnswer.value = recaptcha
  }

  async function getBannerAssineHorizontal(changeLanguage = false) {
    if (!sessionStorage.getItem('bannerAssineHorizontal') || changeLanguage)
      api.get(`v1/home/getBannerSuper?mobile=${isMobile()}&language=${storeLocale.locale}`).then(({ data }) => {
        bannerAssineHorizontal.value = data.bannerAssineHorizontal
        sessionStorage.setItem(
          'bannerAssineHorizontal',
          JSON.stringify(bannerAssineHorizontal.value)
        )
      })
    else bannerAssineHorizontal.value = JSON.parse(sessionStorage.getItem('bannerAssineHorizontal'))
  }

  async function seeMore() {
    relatedLimit.value += isMobile() ? 4 : 9
    await getBlogRelatedPosts(route.params.blogId)
  }

  async function getBlogName(name: string | string[], isCreated: boolean) {
    loading.value = true
    let url = ''
    if (route.query.preview == 'true') url = '&preview=true'
    api
      .get(
        `v1/blog/getBlogId/${name}?language=${
          isCreated ? route.params.locale : storeLocale.locale
        }${url}`,
        {
          headers: {
            'X-Custom-Data': cookies.isKey('commentUser') ? cookies.get('commentUser') : ''
          }
        }
      )
      .then(({ data }) => {
        if (data.blog[0]) {
          if (isCreated) {
            if (data.blog[0].slug === route.params.blogName) {
              data.blog[0].content = data.blog[0].content.replace('https://admin', 'https://api')
              //   data.blog[0].content = this.transformImageTags(data.blog[0].content, (screen.width <= 412 ? 412 : (screen.width <= 640 ? 640 : 808)))
              blog.value = data.blog[0]
              loading.value = false
            } else {
              redirect('404')
            }
          } else {
            router.replace({ params: { blogName: data.blog[0].slug } }).finally(() => {
              if (data.blog[0].slug === route.params.blogName) {
                blog.value = data.blog[0]
                loading.value = false
              } else {
                redirect('404')
              }
            })
          }
          jsonOptions.value = {
            type: 'BlogPosting',
            headline: data.blog[0].title.replace(/\"/g, '\\"'),
            datePublished: data.blog[0].scheduleTime,
            dateModified: data.blog[0].dateTime,
            image: data.blog[0].cover,
            author: storeLocale.locale == 'en' ? 'Bella Club' : 'Bella da Semana',
            url:
              storeLocale.locale == 'en' ? 'https://bellaclub.com' : 'https://belladasemana.com.br'
          }
        } else {
          redirect('404')
        }
      })
      .finally(() => getBlogRelatedPosts(route.params.blogId))
  }

  async function getBlogRelatedPosts(name: string | string[]) {
    loadingButton.value = true
    api
      .get(
        `v1/blog/getBlogRelatedPosts/${name}?language=${storeLocale.locale}&limit=${relatedLimit.value}`
      )
      .then(({ data }) => {
        relatedPosts.value = data.relatedPosts
        loadingButton.value = false
        if (relatedPosts.value.length < relatedLimit.value) {
          showButton.value = false
        }
      })
  }

  function redirect(name: string) {
    router.push({
      name,
      params: {
        locale: storeLocale.locale
      }
    })
  }

  function saveComment(emitMessage: any) {
    let form = {
      nome: nomeComment.value,
      email: emailComment.value,
      newsletter: newsletterComment.value,
      comentario: comentario.value,
      answered_comment_id: '',
      api: true,
      locale: storeLocale.locale
    }

    if (nicknameCommentShow.value) {
      form['nickname'] = nicknameComment.value
    } else {
      form['nickname'] = user.nickname
    }

    form['g-recaptcha-response'] = recaptcha.value

    if (!recaptcha.value)
      return emitMessage({
        message: {
          show: true,
          title: storeLocale.locale == 'pt-br' ? 'Erro' : 'Error',
          textButton: storeLocale.locale == 'pt-br' ? 'Fechar' : 'Close',
          textBoby:
            storeLocale.locale == 'pt-br' ? 'Preencha o Recaptcha!' : 'Complete the Recaptcha'
        }
      })

    api
      .post(`v1/blog/commentBlogId/${storeLocale.locale}/${route.params.blogId}`, form)
      .then(({ data }) => {
        if (nicknameCommentShow.value && nicknameComment.value != '') {
          api.get('v1/myaccount/getUser').then(({ data }) => {
            setUser(data)
          })
        }
        emitMessage({
          message: {
            show: true,
            title: storeLocale.locale == 'pt-br' ? 'Aviso' : 'Notice',
            textButton: storeLocale.locale == 'pt-br' ? 'Fechar' : 'Close',
            textBoby: data.message
          }
        })
        if (data.userId) {
          cookies.set('commentUser', btoa(data.userId), 1000 * 60 * 60 * 24 * 7)
        }
        nomeComment.value = ''
        emailComment.value = ''
        comentario.value = ''
        nicknameComment.value = ''
        nicknameCommentShow.value = false
      })
      .catch((err) => {
        if (err.response.status === 400 && err.response.data.message)
          emitMessage({
            message: {
              show: true,
              title: storeLocale.locale == 'pt-br' ? 'Erro' : 'Error',
              textButton: storeLocale.locale == 'pt-br' ? 'Fechar' : 'Close',
              textBoby: err.response.data.message
            }
          })
        else
          emitMessage({
            message: {
              show: true,
              title: storeLocale.locale == 'pt-br' ? 'Erro' : 'Error',
              textButton: storeLocale.locale == 'pt-br' ? 'Fechar' : 'Close',
              textBoby:
                storeLocale.locale == 'pt-br'
                  ? 'Falha ao enviar comentario!'
                  : 'Failed to send comment!'
            }
          })
      })

    recaptchaExpired()
  }
  function saveCommentAnswer(emitMessage: any) {
    let form = {
      nome: nomeCommentAnswer.value,
      email: emailCommentAnswer.value,
      newsletter: newsletterCommentAnswer.value,
      comentario: comentarioAnswer.value,
      answered_comment_id: answered_comment_id.value,
      api: true,
      locale: storeLocale.locale
    }

    if (nicknameCommentAnswerShow.value) {
      form['nickname'] = nicknameCommentAnswer.value
    } else {
      form['nickname'] = user.nickname
    }

    form['g-recaptcha-response'] = recaptchaAnswer.value

    if (!recaptchaAnswer.value)
      return emitMessage({
        message: {
          show: true,
          title: storeLocale.locale == 'pt-br' ? 'Erro' : 'Error',
          textButton: storeLocale.locale == 'pt-br' ? 'Fechar' : 'Close',
          textBoby:
            storeLocale.locale == 'pt-br' ? 'Preencha o Recaptcha!' : 'Complete the Recaptcha'
        }
      })

    api
      .post(`v1/blog/commentBlogId/${storeLocale.locale}/${route.params.blogId}`, form)
      .then(({ data }) => {
        if (nicknameCommentAnswerShow.value && nicknameCommentAnswer.value != '') {
          api.get('v1/myaccount/getUser').then(({ data }) => {
            setUser(data)
          })
        }
        emitMessage({
          message: {
            show: true,
            title: storeLocale.locale == 'pt-br' ? 'Aviso' : 'Notice',
            textButton: storeLocale.locale == 'pt-br' ? 'Fechar' : 'Close',
            textBoby: data.message
          }
        })
        if (data.userId) {
          cookies.set('commentUser', btoa(data.userId), 1000 * 60 * 60 * 24 * 7)
        }
        nomeCommentAnswer.value = ''
        emailCommentAnswer.value = ''
        comentarioAnswer.value = ''
        answered_comment_id.value = ''
        nicknameCommentAnswer.value = ''
        nicknameCommentAnswerShow.value = false
      })
      .catch((err) => {
        if (err.response.status === 400 && err.response.data.message)
          emitMessage({
            message: {
              show: true,
              title: storeLocale.locale == 'pt-br' ? 'Erro' : 'Error',
              textButton: storeLocale.locale == 'pt-br' ? 'Fechar' : 'Close',
              textBoby: err.response.data.message
            }
          })
        else
          emitMessage({
            message: {
              show: true,
              title: storeLocale.locale == 'pt-br' ? 'Erro' : 'Error',
              textButton: storeLocale.locale == 'pt-br' ? 'Fechar' : 'Close',
              textBoby:
                storeLocale.locale == 'pt-br'
                  ? 'Falha ao enviar comentario!'
                  : 'Failed to send comment!'
            }
          })
      })
    recaptchaExpiredAnswer()
  }

  function toggle(comment) {
    nomeCommentAnswer.value = ''
    emailCommentAnswer.value = ''
    newsletterCommentAnswer.value = true
    comentarioAnswer.value = ''
    nicknameCommentAnswer.value = ''
    nicknameCommentAnswerShow.value = false
    if (answered_comment_id.value == comment.id) {
      answered_comment_id.value = ''
    } else {
      answered_comment_id.value = comment.id
    }
  }
  function showNickname(nickname: string) {
    nicknameComment.value = nickname
    nicknameCommentShow.value = true
  }
  function showNicknameAnswer(nickname: string) {
    nicknameCommentAnswer.value = nickname
    nicknameCommentAnswerShow.value = true
  }
</script>
<template>
  <JsonLD :jsonOptions="jsonOptions" />
  <MainLayout #="{ showModalMessages }">
    <div class="slot-body">
      <div class="container px-3">
        <LoadingTag v-model:active="loading" :is-full-page="false" color="#b20000" />
        <div class="row pt-3 align-items-center justify-content-center">
          <div class="box-title pt-3">
            <h1 class="title">{{ blog.title }}</h1>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-12 d-flex align-items-center justify-content-center">
            <div id="slot-post-api" v-html="blog.content"></div>
          </div>
          <div class="col-lg-12 d-flex align-items-center justify-content-center">
            <div class="box-details">
              <div class="row justify-content-space-between">
                <p class="card-text small col-lg-3 col-12">
                  <font-awesome-icon :icon="['far', 'clock']" size="sm" />
                  {{ translate.publishedDate }} {{ blog.schedule }}
                </p>
                <p class="card-text small col-lg-4 col-12">
                  <font-awesome-icon :icon="['far', 'clock']" size="sm" />
                  {{ translate.modifiedDate }} {{ blog.date }}
                </p>
                <p class="card-text small col-lg-2 col-12">
                  <font-awesome-icon :icon="['far', 'comment-dots']" size="sm" />
                  {{ blog.comments }}
                  {{ translate.commentsBlog }}
                </p>
                <div class="card-text col-lg-3 col-12 share-align">
                  <span>{{ translate.share }}</span>
                  <font-awesome-icon
                    :icon="['fas', 'share-nodes']"
                    size="sm"
                    style="color: #b20000; margin-left: 3px"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-12 d-flex align-items-center justify-content-center">
            <RelatedPosts :posts="relatedPosts" />
          </div>
          <div v-if="showButton">
            <div class="d-flex justify-content-center mt-3" v-if="!loadingButton">
              <a class="button mt-2" href="#" @click.prevent="seeMore">
                {{ translate.labelButton }}
                <i class="icon-arrow-right"></i>
              </a>
            </div>
            <div v-else class="text-center spin-load my-4">
              <div class="spinner-border" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
            </div>
          </div>
          <div v-else class="mb-5"></div>
        </div>
      </div>
      <div class="box-gray px-3">
        <div class="container">
          <div class="row d-flex align-items-center justify-content-center">
            <div class="box-w">
              <span class="title-comments" v-if="blog.listComents.length">{{
                translate.commentAllBox
              }}</span>
              <div class="list-comentarios" v-if="blog.listComents.length">
                <div v-for="(comment, index) in blog.listComents" :key="index" class="card-comment">
                  <div>
                    <img
                      v-if="comment.ativo == 'true'"
                      :src="IconeBds"
                      alt="Assinante"
                      title="Assinante"
                      width="12"
                      height="12"
                    />
                    <span>
                      <strong>
                        {{
                          comment.name
                            ? comment.name
                            : storeLocale.locale == 'pt-br'
                            ? 'Anônimo'
                            : 'Anonymous'
                        }}
                      </strong>
                    </span>
                    {{ translate.wroteOn }} {{ comment.date }}
                    <span class="a-answer text-answer" @click="toggle(comment)">
                      {{ translate.answer }}</span
                    >
                  </div>
                  <legend>{{ comment.comment }}</legend>
                  <hr />
                  <div
                    v-for="(commentAnswer, indexAnswer) in comment.answers"
                    :key="indexAnswer"
                    class="card-comment answer"
                  >
                    <div>
                      <img
                        v-if="commentAnswer.ativo == 'true'"
                        :src="IconeBds"
                        alt="Assinante"
                        title="Assinante"
                        width="12"
                        height="12"
                      />
                      <span>
                        <strong>
                          {{
                            commentAnswer.name
                              ? commentAnswer.name
                              : storeLocale.locale == 'pt-br'
                              ? 'Anônimo'
                              : 'Anonymous'
                          }}
                        </strong>
                      </span>
                      {{ translate.wroteOn }} {{ commentAnswer.date }}
                    </div>
                    <legend>{{ commentAnswer.comment }}</legend>
                    <hr />
                  </div>
                  <div v-if="answered_comment_id === comment.id" class="box-w-2 answer">
                    <div class="questionario row">
                      <input
                        type="hidden"
                        class="form-control"
                        name="answered_comment_id"
                        v-model="answered_comment_id"
                      />
                      <span class="quest-title"> {{ translate.yoursComment }}</span>
                      <span class="quest-nickname" v-if="user.name">
                        {{ translate.yourNickname }} {{ user.nickname ?? user.name }} (
                        <a @click="showNicknameAnswer(user.nickname)" class="alter-nickname">{{
                          translate.alterNickName
                        }}</a>
                        )
                        <input
                          v-if="nicknameCommentAnswerShow"
                          class="form-control"
                          required
                          type="text"
                          v-model="nicknameCommentAnswer"
                        />
                      </span>
                      <div class="row" v-else>
                        <div class="col-6">
                          <div class="form-group">
                            <input
                              type="text"
                              class="form-control"
                              name="name"
                              :placeholder="translate.yourName"
                              v-model="nomeCommentAnswer"
                            />
                          </div>
                        </div>
                        <div class="col-6">
                          <div class="form-group">
                            <input
                              type="text"
                              class="form-control"
                              name="email"
                              :placeholder="translate.yourEmail"
                              v-model="emailCommentAnswer"
                            />
                          </div>
                        </div>
                        <div class="col-lg-6 col-12 accept mt-3">
                          <input
                            type="checkbox"
                            name="acept"
                            id="acept"
                            v-model="newsletterCommentAnswer"
                          />
                          <label for="checkbox">{{ translate.formNewsCheck }}</label>
                        </div>
                      </div>
                      <div class="mb-3">
                        <textarea
                          class="form-control"
                          id="text-comment-bella"
                          :placeholder="translate.inputComment"
                          rows="5"
                          v-model="comentarioAnswer"
                        ></textarea>
                      </div>
                      <vue-recaptcha
                        ref="redAnswer"
                        v-if="showRecaptchaAnswer"
                        :sitekey="recaptchaSiteKey"
                        v-on:verify="recaptchaUpdatedAnswer"
                        hl="pt-br"
                      ></vue-recaptcha>
                      <a class="button mt-2" @click="saveCommentAnswer(showModalMessages)">
                        {{ translate.button }}
                        <i class="icon-arrow-right"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="box-w-2">
              <div class="questionario row">
                <span class="quest-title"> {{ translate.yoursComment }}</span>
                <span class="quest-nickname" v-if="user.name">
                  {{ translate.yourNickname }} {{ user.nickname ?? user.name }} (
                  <a @click="showNickname(user.nickname)" class="alter-nickname">{{
                    translate.alterNickName
                  }}</a>
                  )
                  <input
                    v-if="nicknameCommentShow"
                    class="form-control"
                    required
                    type="text"
                    v-model="nicknameComment"
                  />
                </span>
                <div class="row" v-else>
                  <div class="col-6">
                    <div class="form-group">
                      <input
                        type="text"
                        class="form-control"
                        name="cpf"
                        :placeholder="translate.yourName"
                        v-model="nomeComment"
                      />
                    </div>
                  </div>
                  <div class="col-6">
                    <div class="form-group">
                      <input
                        type="text"
                        class="form-control"
                        name="cpf"
                        :placeholder="translate.yourEmail"
                        v-model="emailComment"
                      />
                    </div>
                  </div>
                  <div class="col-lg-6 col-12 accept mt-3">
                    <input type="checkbox" name="acept" id="acept" v-model="newsletterComment" />
                    <label for="checkbox">{{ translate.formNewsCheck }}</label>
                  </div>
                </div>
                <div class="mb-3">
                  <textarea
                    class="form-control"
                    id="text-comment-bella"
                    :placeholder="translate.inputComment"
                    rows="5"
                    v-model="comentario"
                  ></textarea>
                </div>
                <vue-recaptcha
                  ref="red"
                  v-if="showRecaptcha"
                  :sitekey="recaptchaSiteKey"
                  v-on:verify="recaptchaUpdated"
                  hl="pt-br"
                ></vue-recaptcha>
                <a class="button mt-2" href="#" @click.prevent="saveComment(showModalMessages)">
                  {{ translate.button }}
                  <i class="icon-arrow-right"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="container">
        <div class="row pb-5 pt-5 d-flex align-items-center justify-content-center">
          <BannerAssineHorizontal :path="bannerAssineHorizontal" />
        </div>
      </div>
    </div>
  </MainLayout>
</template>
<style lang="css">
  .meuBotao {
    background-color: black!important;  /* Cor de fundo preta */
    color: white; /* Cor da fonte branca */
    font-size: 22px;
    font-weight: bold;
    border-radius: 22px; /* Tamanho da fonte */
    border: none; /* Remove a borda padrão */
    padding: 10px 20px; /* Espaçamento interno */
    cursor: pointer; /* Muda o cursor para indicar que é clicável */
    transition: background-color 0.3s; /* Transição suave para a cor de fundo */
  }
  .meuBotao:hover {
    background-color: #b20000 !important;
    opacity: 0.8; /* Efeito de clareamento */
  }
</style>
<style scoped lang="css">
  label {
    height: 23px;
    color: #5b5858;
    font-family: 'Roboto-Regular';
    font-size: 16px;
    letter-spacing: 0;
    line-height: 23px;
  }

  input[type='checkbox'] {
    position: relative;
    cursor: pointer;
    margin-inline: 15px;
    width: 20px;
    height: 20px;
  }

  input[type='checkbox']:before {
    content: '';
    display: block;
    position: absolute;
    width: 30px;
    height: 30px;
    border-radius: 8px;
    top: -3px;
    left: -3px;
    background-color: #000;
  }

  input[type='checkbox']:checked:before {
    content: '';
    display: block;
    position: absolute;
    width: 30px;
    height: 30px;
    top: -3px;
    left: -3px;
    background-color: #000;
  }

  input[type='checkbox']:checked:after {
    content: '';
    display: block;
    width: 9px;
    height: 15px;
    border: solid red;
    border-width: 0 2px 2px 0;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
    position: absolute;
    top: 2px;
    left: 6px;
  }

  .form-group input {
    padding: 15px 20px;
    border-radius: 30px;
    background-color: #fff;
    font-size: small;
  }

  .form-control:focus {
    color: #000;
    background-color: #f8f8f8;
  }

  .img-banner-rodape {
    height: 124px;
    width: 1012px;
  }

  .button {
    height: 50px;
    width: 142px;
    margin-bottom: 56px;
    cursor: pointer;
    border-radius: 30px;
    margin-left: 10px;
  }

  .quest-title {
    color: #b20000;
    font-family: 'Roboto-Medium';
    font-size: 24px;
    font-weight: 500;
    letter-spacing: 0;
    line-height: 28px;
    margin-bottom: 5px;
  }

  .quest-nickname {
    color: #5b5858;
    font-family: 'Roboto-Regular';
    font-size: 16px;
    letter-spacing: 0;
    line-height: 16px;
  }

  .form-control {
    margin-top: 10px;
    background-color: #fff;
    color: #868686;
    font-size: 14px;
    font-weight: 600;
    font-family: 'Exo-2';
  }

  .card-comment > div {
    font-family: 'Roboto-Regular';
    font-size: 13px;
  }

  .card-comment > legend {
    font-family: 'Roboto-Regular';
    font-size: 16px;
    line-height: 19px;
  }

  .card-comment > div > span {
    font-family: 'Roboto-Bold';
    font-size: 13px;
    color: #000;
  }

  .card-comment > hr {
    margin-bottom: 10px !important;
  }

  .answer {
    padding-left: 50px !important;
  }

  .text-answer {
    color: #b20000 !important;
    font-size: 14px;
    cursor: pointer;
    padding-left: 10px;
  }

  .slot-body {
    margin-top: 65px !important;    
    background-color: #fff !important;
    text-align: justify;
  }

  #slot-post-api {
    max-width: 808px;
    min-height: 900px;
  }

  .list-comentarios {
    margin-top: 5px;
  }

  .box-title {
    max-width: 808px;
    padding-inline: 0;
  }

  .box-details {
    width: 808px;
    padding-inline: 0;
    margin-top: 20px;
  }

  .box-gray {
    background-color: #f8f8f8;
    width: 100%;
  }

  .box-details span {
    font-size: 16px;
    line-height: 19px;
    color: #666;
  }

  .box-w {
    margin-top: 50px;
    width: 808px;
    padding-inline: 0;
  }

  .box-w-2 {
    margin-top: 50px;
    width: 808px;
    padding-inline: 0;
  }

  .title-comments {
    color: #b20000;
    font-family: 'Roboto-Medium';
    font-size: 24px;
    line-height: 28px;
    padding-inline: 0;
  }

  .card-text {
    font-family: 'Roboto-Regular';
    font-size: 13px;
    line-height: 15px;
    color: #999;
  }

  .title {
    font-family: 'Roboto-Medium';
    text-align: start;
    font-size: 36px;
    line-height: 66px;
    color: #b20000;
  }

  .card-comment img {
    width: 12px;
    margin-right: 5px;
    object-fit: cover;
  }

  .button {
    height: 50px;
    width: 170px;
    margin-bottom: 56px;
    cursor: pointer;
    border-radius: 30px;
  }

  :deep(#slot-post-api > h2 > span) {
    font-size: 24px !important;
    color: #000;
    font-weight: 700;
  }

  :deep(span) {
    font-family: 'Roboto-Regular', sans-serif !important;
  }

  :deep(strong) {
    font-family: 'Roboto-Regular', sans-serif !important;
  }

  :deep(b) {
    font-family: 'Roboto-Regular', sans-serif !important;
  }

  .alter-nickname {
    color: #b20000;
    cursor: pointer;
    font-size: 13px;
  }

  .share-align {
    display: flex;
    justify-content: flex-end !important;
  }

  :deep(.iframe-video-blog) {
    max-width: 808px !important;
  }

  :deep(#slot-post-api > div > img) {
    min-height: 500px;
  }


  /* regras mobile 769vp */
  @media screen and (max-width: 769px) {
    .title {
      font-family: 'Roboto-Medium';
      text-align: start;
      font-size: 36px;
      line-height: 40px;
      color: #b20000;
    }

    #slot-post-api {
      max-width: 100%;
      min-height: 1900px;
    }

    :deep(#slot-post-api > div > img) {
      min-height: 200px;
    }

    :deep(#slot-post-api img) {
      width: 100%;
    }

    .img-banner-rodape {
      height: unset;
      width: 90%;
    }

    .share-align {
      display: flex;
      justify-content: flex-start !important;
    }

    :deep(.iframe-video-blog) {
      width: 100% !important;
      height: 300px !important;
    }
  }
</style>
